var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5",staticStyle:{"width":"100%"}},[_c('Navigation'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }